import { useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';

const loginStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=Manrope:wght@400;600;700;800&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #00091f; }
  .login-page {
    min-height: 100vh; display: flex; align-items: center; justify-content: center;
    background: #00091f;
    background-image:
      radial-gradient(ellipse 80% 60% at 50% -10%, rgba(11,204,249,0.08) 0%, transparent 60%),
      radial-gradient(ellipse 50% 50% at 90% 90%, rgba(0,27,113,0.3) 0%, transparent 60%);
    font-family: 'DM Mono', monospace;
  }
  .login-card {
    background: #001040; border: 1px solid rgba(11,204,249,0.2);
    border-radius: 16px; padding: 48px 40px; width: 100%; max-width: 400px;
    text-align: center; box-shadow: 0 24px 80px rgba(0,0,0,0.4);
  }
  .login-logo {
    font-family: 'Manrope', sans-serif; font-size: 22px; font-weight: 800;
    color: #e8f4ff; margin-bottom: 6px; letter-spacing: 0.5px;
  }
  .login-logo span { color: #0BCCF9; }
  .login-subtitle {
    font-size: 12px; color: #7a8baa; margin-bottom: 36px; letter-spacing: 0.5px;
  }
  .login-divider {
    width: 40px; height: 2px; background: #0BCCF9;
    margin: 0 auto 36px; border-radius: 2px;
  }
  .login-title {
    font-family: 'Manrope', sans-serif; font-size: 18px; font-weight: 700;
    color: #e8f4ff; margin-bottom: 10px;
  }
  .login-desc { font-size: 12px; color: #7a8baa; margin-bottom: 32px; line-height: 1.6; }
  .login-btn {
    width: 100%; padding: 14px 24px;
    background: linear-gradient(135deg, #001B71, #0B4BAA);
    border: 1px solid rgba(11,204,249,0.3); border-radius: 10px;
    color: #e8f4ff; font-family: 'Manrope', sans-serif;
    font-size: 14px; font-weight: 700; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 10px;
    transition: all 0.2s; letter-spacing: 0.5px;
  }
  .login-btn:hover {
    background: linear-gradient(135deg, #002090, #0B5FCC);
    border-color: rgba(11,204,249,0.5);
    transform: translateY(-1px); box-shadow: 0 8px 24px rgba(0,27,113,0.4);
  }
  .login-btn:active { transform: translateY(0); }
  .login-icon { font-size: 18px; }
  .login-footer { margin-top: 28px; font-size: 10px; color: #404B68; line-height: 1.6; }
  .login-footer span { color: #0BCCF9; }
  .login-secure {
    display: flex; align-items: center; justify-content: center; gap: 6px;
    margin-top: 20px; font-size: 11px; color: #404B68;
  }
`;

export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(console.error);
  };

  return (
    <>
      <style>{loginStyles}</style>
      <div className="login-page">
        <div className="login-card">
          <div className="login-logo">CUSTOS <span>XIIBERO</span></div>
          <div className="login-subtitle">PAYMENT PLATFORM · MERCHANT PORTAL</div>
          <div className="login-divider" />
          <div className="login-title">Acceso al Portal</div>
          <div className="login-desc">
            Accede con tus credenciales para ver el dashboard de transacciones
            en tiempo real de tu merchant.
          </div>
          <button className="login-btn" onClick={handleLogin}>
            <span className="login-icon">🔐</span>
            Iniciar sesión
          </button>
          <div className="login-secure">
            🔒 Acceso protegido · MFA requerido
          </div>
          <div className="login-footer">
            CUSTOS XIIBERO Payment Platform<br />
            <span>portal-xiibero.custosmobile.com</span>
          </div>
        </div>
      </div>
    </>
  );
}
